export const READONLY_PERMISSION = 'No tienes los permisos para realizar esta acción, contacta a un administrador.';
